const VIETNAM_SLUGS = new Set([
  'danang',
  'ho chi minh',
  'hanoi',
  'hoi an',
  'nha trang',
  'hồ chí minh',
  'ha noi',
]);

export function slugifyRegion(name) {
  if (!name || typeof name !== 'string') return '';
  return name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '');
}

/** 사용자 지역 문자열 → 매칭용 슬러그 목록 */
export function userRegionSlugs(selectedRegions) {
  const set = new Set();
  if (!Array.isArray(selectedRegions)) return set;
  for (const raw of selectedRegions) {
    const s = slugifyRegion(raw);
    if (!s) continue;
    set.add(s);
    if (s.includes('danang')) set.add('danang');
    if (s.includes('hochiminh') || s.includes('saigon')) set.add('hochiminh');
    if (s.includes('hanoi')) set.add('hanoi');
  }
  if (set.size > 0) set.add('vietnam');
  return set;
}

export { VIETNAM_SLUGS };
